import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, } from 'react-redux';
import { CardBody, Button } from 'reactstrap';
import { translate } from "react-translate";
import TableAssets from './TableAssets';
import Paginator from '../Common/Paginator';
import Search from '../Common/Search'
import Loading from "plugins/TS-lib-utils-public/components/Loading/LoadingGlobal";
import { actionGetAssetsList } from 'store/actions/assetsActions';
import { useHistory } from 'react-router-dom';

const AssetsList = (props) => {
    const dispatch = useDispatch();
    const { data, page, lastPage, limit } = useSelector(state => state.assetsReducer.assets);
    const [loading, setloading] = useState(false);
    const [loadingLocal, setloadingLocal] = useState(false);
    const [_page, setPage] = useState(0);
    const [_limit, setLimit] = useState(10);
    const [totalPage, setTotalPage] = useState(0);
    const [filter, setFilter] = useState(null);
    const history = useHistory();

    useEffect(() => {
        dispatch(actionGetAssetsList(_page, _limit));
    }, []);

    useEffect(() => {

        if (data) {
            setloading(false);
            setloadingLocal(false);
            setPage(page);
            setLimit(limit);
            setTotalPage(lastPage);
        }

    }, [dispatch, data]);

    //method called by paginator and search
    function changeDataSearch(page, filter) {
        //if the search type "" refresh all data
        setloadingLocal(true)
        if (filter == null) {
            setFilter(null);
            dispatch(actionGetAssetsList(page, _limit));
        } else {
            //we save search input text, therefore we will only paginate the search results
            setFilter(filter);
            dispatch(actionGetAssetsList(page, _limit, filter));
        }
    }

    const createAsset = (e) => {
        e.preventDefault();
        history.push(`/admin/assets/form/`);
    }

    return (
        <div className='content user-manual'>
                <CardBody>
                    <div>
                        <Loading loading={loading} />
                        <Search placeholder={"search-text-logList"} callback={changeDataSearch}/>

                        <Button
                            size="sm"
                            color="info"
                            onClick={(e) => { createAsset(e) }}
                            >
                            Add new asset
                        </Button>

                        <TableAssets data={data} loading={loadingLocal} page={_page} callback={changeDataSearch}/>
                        <Paginator totalPages={totalPage} currentPage={_page} pageSize={_limit} filter={filter} callback={changeDataSearch} />
                    </div>
                </CardBody>
        </div>
    );
};
export default translate("assets")(AssetsList);